import { useTranslation } from 'react-i18next';
import { SearchBox } from './SearchBox';
import { TagSelect } from './TagSelect';
import type { IListToolbarProps } from './IListToolbarProps';
import './toolbar.css';

/**
 * Панель дій списку (UIUX controls/toolbar, tables/toolbar; прототип v4): сіра смуга з рамкою й радіусом 10px, ліва група дій (TableActions)
 * і праворуч — «Усі теги» та пошук «Шукати за назвою або ID» (220px). Пошук (після паузи введення) і тег зберігаються в стані пункту меню й скидають сторінку.
 */
export function ListToolbar({ model, children }: IListToolbarProps) {
  const { t } = useTranslation();
  return (
    <div className="lv-toolbar" role="toolbar" aria-label={t('listbar.actions')}>
      {children}
      <span className="lv-toolbar__spacer" />
      <TagSelect ws={model.ws} value={model.state.tagFilter} onChange={(tags) => model.setState({ tagFilter: tags })} />
      <SearchBox value={model.state.search} onChange={(search) => model.setState({ search })} />
    </div>
  );
}
